<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">加入我的最愛</h3>
        </div>
        <div class="modal-body" style="min-height:200px;">
            <h5>請輸入我的最愛標題。  (必填)</h5>
            <form>
                <div class="row  form-group">
                    <div class="col-12">
                        <input type="text" v-model="favorName" class="form-control" maxlength="40" @input="checkFavorName" />
                    </div>
                </div>
                <div class="action text-right">
                    <a @click="checkSubmit()" class="btn btn-primary">送出</a>
                </div>
            </form>
        </div>
      </div>
    </div>
  
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'SearchResultFarvoriteModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    open (val) {
      if (val) {
        this.favorName = ''
      }
    },
  },
  data() {
    return {
      favorName: '',
    }
  },
  methods: {
    //檢查我的最愛標題
    checkFavorName(){
      if (this.stringBytes(this.favorName, false, 40) > 40) {
        this.favorName = this.favorName.substring(0, this.stringBytes(this.favorName, true, 40));
      }
    },
    checkSubmit () {  // 確認送出
      if(this.favorName.trim() == '') {return this.setToastMsg('標題不得為空白')}

      this.$emit('submit', this.favorName)
    },
    stringBytes(c, isSub, size){ //計算字元長度 (字串, 是否檢查, 檢查的長度) 
      var n=c.length,s;
      var len=0;
      for(var i=0; i <n;i++){
        s=c.charCodeAt(i);
        while( s > 0 ){
          len++;
          s = s >> 8;
          if(isSub&&len>size){
            return i;
          }
        }
      }
      return len;
    }
  }
}
</script>
